import { useRef, useCallback } from 'react';

export default function useMultipleRefs() {
  const refs = useRef({});
  
  const setRef = useCallback((key, element) => {
    if (element) {
      refs.current[key] = element;
    } else {
      delete refs.current[key];
    }
  }, []);
  
  const getRef = useCallback((key) => refs.current[key], []);
  const getAllRefs = useCallback(() => refs.current, []);
  
  return { setRef, getRef, getAllRefs };
}